import { z } from 'zod';
import { PortalConsumerSchema, PortalEntityTypeSchema, } from '../../base/portal.js';
import { PortalZoneSchema } from '../../base/zones.js';
export const ListEntityPortalsRequestPathSchema = z.object({
    entityId: z.string(),
    entityType: PortalEntityTypeSchema,
});
export const ListEntityPortalsRequestQueryStringSchema = z.object({
    includeInactive: z.coerce.boolean(),
    zone: PortalZoneSchema.optional(),
});
export const ListEntityPortalsRequestSchema = ListEntityPortalsRequestPathSchema.merge(ListEntityPortalsRequestQueryStringSchema);
export const ListEntityPortalSchema = PortalConsumerSchema;
export const ListEntityPortalsResponseSchema = z.object({
    portals: z.array(ListEntityPortalSchema),
});
export const ListEntityPortalsApiSchema = {
    params: ListEntityPortalsRequestPathSchema,
    query: ListEntityPortalsRequestQueryStringSchema,
    response: ListEntityPortalsResponseSchema,
};
